import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["alert"]

  dismiss() {
    this.element.style.display = "none" // Hide the alert when dismiss button is clicked
  }
}
